export default "__VITE_ASSET__ClMh0$gM__"